module.exports = __webpack_public_path__ + "img/shipping agent_xuanzhong.f61d2985.png";